import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container, HtmlContent } from './ui';

const StyledTable = styled.section`
  ${({ isBlogSingle }) => {
    if (isBlogSingle) {
      return sectionMargins('20px', '40px');
    } else {
      return sectionMargins();
    }
  }}
`;

const StyledContainer = styled(Container)`
  position: relative;
  padding-right: 0;
  padding-left: 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 20px;

    ${minBreakpointQuery.smedium`
      width: 30px;
    `}
  }

  &:before {
    left: 0;
    background: linear-gradient(
      to left,
      ${standardColours.transparent},
      ${standardColours.white} 90%
    );
  }

  &:after {
    right: 0;
    background: linear-gradient(
      to right,
      ${standardColours.transparent},
      ${standardColours.white} 90%
    );
  }
`;

const StyledContent = styled(HtmlContent)`
  padding: 0 20px;

  ${maxBreakpointQuery.mlarge`
    overflow-x: scroll;
  `}

  ${minBreakpointQuery.smedium`
    padding-right: 30px;
    padding-left: 30px;
  `}
`;

const Table = ({ html, isBlogSingle }) => (
  <StyledTable isBlogSingle={isBlogSingle}>
    <StyledContainer>
      <StyledContent html={html} />
    </StyledContainer>
  </StyledTable>
);

export default Table;
